// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.


export const environment = {
  production: false,
  backendApi : 'https://api.doxx.care/api/',
  firebase: {
    apiKey: "AIzaSyCa2A-ZFHPh-kzxinClJw-L1rKjNzx_Q_M",
    authDomain: "doxx-85cc4.firebaseapp.com",
    projectId: "doxx-85cc4",
    storageBucket: "doxx-85cc4.appspot.com",
    messagingSenderId: "901172558897",
    appId: "1:901172558897:web:cea96b7838b201fca8e910",
    measurementId: "G-9DB69WC0BD" , 
    vapidKey:'BCPqfLU_UrNQgpEkKQcDf894SobdbsCK8Tpec_YMOeJeAG2CHakwPxCdvhc9KStC97xr07eZxdEysnS4i93eh2w'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
